/**
 * The app-wide screen-reader voice: one polite and one assertive live region,
 * always mounted (a region inserted together with its text is often not read).
 * Text is cleared and re-set so a repeated message is announced again.
 */
import { useEffect, useState } from 'react';
import { useUiStore } from '../state/uiStore';

export function LiveAnnouncer() {
  const announcement = useUiStore((s) => s.announcement);
  const [polite, setPolite] = useState('');
  const [assertive, setAssertive] = useState('');

  useEffect(() => {
    if (!announcement) return;
    const set = announcement.politeness === 'assertive' ? setAssertive : setPolite;
    set('');
    const timer = setTimeout(() => set(announcement.text), 60);
    return () => clearTimeout(timer);
  }, [announcement]);

  return (
    <>
      <div className="sr-only" aria-live="polite" aria-atomic="true" data-testid="live-polite">
        {polite}
      </div>
      <div className="sr-only" aria-live="assertive" aria-atomic="true" data-testid="live-assertive">
        {assertive}
      </div>
    </>
  );
}
